import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import classnames from 'classnames';
import {Button} from 'ui-library';

module.exports = createClass({
  displayName: 'NavigationBar',

  propTypes: {
    title: PropTypes.any,
    className: PropTypes.string,

    leftButton: PropTypes.any,
    onClickLeftButton: PropTypes.func,

    rightButton: PropTypes.any,
    onClickRightButton: PropTypes.func,

    onClose: PropTypes.func,
    options: PropTypes.object
  },

  getDefaultProps() {
    return {
      title: 'VoxFeed',
      rightButton: <i className='vf-icon icon-hamburger'></i>,
      options: {
        showLeftButton: true,
        showRightButton: false
      }
    };
  },

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  },

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  },

  handleClickOutside(ev) {
    if (!!this.props.onClose && !!this.container && !this.container.contains(ev.target)) {
      this.props.onClose();
    }
  },

  renderLeftButton() {
    const {leftButton} = this.props;
    return leftButton || <i className='vf-icon icon-hamburger show-in-small' />;
  },

  render() {
    const {rightButton, onClickRightButton, onClickLeftButton, title, className, options} = this.props;
    const containerClassName = classnames('vf-navigation-bar', className);

    return (
      <div ref={r => this.container = r} className={containerClassName}>
        {options.showLeftButton && (
          <Button
            onClick={onClickLeftButton}
            className='vf-navigation-bar-button-left no-border vf-btn--no-shado'
            style={{height: '100%'}}
          >
            {this.renderLeftButton()}
          </Button>
        )}

        {options.showRightButton && (
          <Button
            onClick={onClickRightButton}
            className='vf-navigation-bar-button-right vf-btn--no-shado'
            style={{height: '100%'}}
          >
            {rightButton}
          </Button>
        )}

        <h2>{title}</h2>
      </div>
    );
  }
});
